import styled from "styled-components/macro";

export const StyledMenu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #ffffff;
  border: none;
  padding: 1rem 0 0 0.5rem;
  margin: 0;
  position: fixed;
  height: 100vh;
  z-index: 2000;
  top: 0;
  left: 0;
  width: 55%;
  border-radius: 0 6px 6px 0;
  transition: transform 1s ease-in-out;
  transform: ${({ openMenu }) =>
    openMenu ? "translateX(0)" : "translateX(-120%)"};
  @media (min-width: 992px) {
    display: none;
  }
`;
export const ContainerScroll = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
`;
export const ContainerHead = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;

  @media (min-width: 992px) {
    display: none;
  }
`;

export const TextProode = styled.h3`
  margin: 0;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #a71b38;
  text-align: center;
  padding-top: 0.8rem;
`;
export const Button = styled.button`
  background-color: transparent;
  border: none;

  text-decoration: none;
  &:focus {
    text-decoration: none;
  }
`;
export const ContainerIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  margin: 1.5rem 0;
  a {
    margin: 0 0 0 1rem;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: #a71b38;
    text-align: center;
    cursor: pointer;
    text-decoration: none;
  }
`;
export const ContainerModal = styled.div`
  position: absolute;
  bottom: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  text-align: start;
  padding-right: 0.4rem;

  p {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 300;
    text-align: center;
    font-size: 12px;
    line-height: 18px;
    text-decoration: none;
    margin: 0;
  }
  a {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 300;
    text-align: center;
    color: #a71b38;
    font-size: 12px;
    line-height: 10px;
    text-decoration: none;
    text-align: start;
    margin: 0;
  }
`;
